export default "__VITE_ASSET__C_mJjl0y__"